import type { ReactNode } from 'react';
import { useAuthStore } from '@/stores/auth-store';

type Role = 'admin' | 'manager' | 'employee';

const ROLE_HIERARCHY: Record<Role, number> = {
  admin: 3,
  manager: 2,
  employee: 1,
};

interface RoleGateProps {
  minimumRole: Role;
  children: ReactNode;
  fallback?: ReactNode;
}

export function RoleGate({ minimumRole, children, fallback = null }: RoleGateProps) {
  const profile = useAuthStore((s) => s.profile);

  if (!profile) return null;

  const userLevel = ROLE_HIERARCHY[profile.role] ?? 0;
  const requiredLevel = ROLE_HIERARCHY[minimumRole];

  if (userLevel < requiredLevel) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
}
